import { useIntl } from 'react-intl'

import BaseCompactCard from './BaseCompactCard'

import { ItemMetadata } from 'tripPlanner/models'
import type { CruiseItem, TourItem } from 'tripPlanner/types/tripItem'
import type { DetailItemCardVariant } from '../DetailItemCard/common/types'

interface Props {
  item: TourItem | CruiseItem
  presentationType: 'start' | 'end' | 'intermediary'
  variant: DetailItemCardVariant
}

function CompactTourCruiseCard({ item, presentationType, variant }: Props) {
  const intl = useIntl()
  const { type, startPlace } = item
  const { icon: Icon, singularName } = ItemMetadata[type]

  const title = item.name ?? intl.formatMessage(
    {
      id: '5CXfCGTYrq5h2mFRZ8le',
      defaultMessage: '{transportType} from {placeName}',
      description: 'Tour or cruise compact card fallback title showing type and departure location',
    },
    { transportType: intl.formatMessage(singularName), placeName: startPlace.name },
  )

  return (
    <BaseCompactCard
      item={item}
      icon={<Icon size="S" />}
      title={title}
      isPrimary={presentationType === 'start'}
      variant={variant}
    />
  )
}

export default CompactTourCruiseCard
